<template lang="pug">
  main
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Nueva Factura 
              |
              router-link.a.button.is-dark.is-rounded(to='/Facturas')
                i.fas.fa-
            br
        .columns
          .column.is-3
            .field
              label.label FACTURA
              .control
                input.input.is-dark(
                  type='text',
                  v-model="factura",
                )
          .column.is-2
            .field
              label.label EMPRESA
              .control
                input.input.is-dark(
                  type='text', 
                  v-model="empresa",
                )
          .column.is-2
            .field
              label.label MES
              .control
                input.input.is-dark(
                  type='text', 
                  v-model="mes",
                )
          .column.is-2
            .field
              label.label AREA
              .control
                input.input.is-dark(
                  type='text',
                  v-model="area",
                )
          .column.is-3
            .field
              label.label PARTIDA PRESUPUESTAL
              .control
                input.input.is-dark(
                  type='text',
                  v-model="partidaPresupuestal",
                )
        .columns       
          .column.is-3
            .field
              label.label ORDEN DE COMPRA
              .control
                input.input.is-dark(
                  type='text',
                  v-model="ordenCompra",
                )
          .column.is-2
            .field
              label.label FECHA DE FACTURA
              .control
                flat-pickr(
                  v-model="fechaFactura"
                  :config="config"
                  class="input is-dark" 
                )
          .column.is-2
            .field
              label.label SERIE
              .control
                input.input.is-dark(
                  type='text',
                  v-model="serie",
                )
          .column.is-2
            .field
              label.label FOLIO
              .control
                input.input.is-dark(
                  type='text',
                  v-model="folio",
                )
          .column.is-2
            .field
              label.label UUID
              .control
                input.input.is-dark(
                  type='text',
                  v-model="UUID",
                )
        .columns
          .column.is-3
            .field
              label.label PROVEEDOR
                Typeahead(:options="proveedores" :optionSelect="proveedorSel" :tema="tema" v-model="proveedorSel")
          .column.is-2
            .field
              label.label RFC
              .control
                input.input.is-dark(
                  type='text',
                  v-model="RFC",
                )
          .column.is-2
            .field
              label.label MONEDA
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="moneda")
                    option(v-for="m in monedas" :key="m.id" :value="m.id") {{ m.prefijo }} {{ m.moneda }}
          .column.is-2
            .field
              label.label MONTO
              .control
                input.input.is-dark(
                  type='text',
                  v-model="monto",
                )
          .column.is-3
            .field
              label.label CONCEPTO
              .control
                input.input.is-dark(
                  type='text',
                  v-model="concepto",
                )
        .columns
          .column.is-2
            .field
              label.label FECHA DE PAGO
              .control
                flat-pickr(
                  v-model="fechaPago"
                  :config="config"
                  class="input is-dark" 
                )
          .column.is-2
            .field
              label.label METODO DE PAGO
              .control
                input.input.is-dark(
                  type='text', 
                  v-model="metodoPago",
                )
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger {{ datosF }}
        .columns
          .column.is-3
            a.button.is-black.is-rounded.is-medium(@click="addFactura") Guardar
</template>

<script>
import moment from 'moment'
import Loader from '../shared/Loader.vue'
import { mapState } from 'vuex'
import Typeahead from './Typeahead'
import FormProveedor from '../requisiciones_Componentes/FormProveedor.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import InventarioServices from '../../services/inventario/inventario'

export default {
  name: 'NuevaFactura',
  components: { Loader, flatPickr, Typeahead, FormProveedor},
  data () {
    return {
      facturas: {
        factura: '',
        empresa: '',
        mes:'',
        area:'',
        partidaPresupuestal:'',
        ordenCompra:'',
        serie:'',
        folio:'',
        UUID:'',
        idProveedor:'',
        RFC:'',
        moneda: 0,
        monto:'',
        concepto:'',
        metodoPago :'',
        fechaFactura: '',
        fechaPago: '',
        },
      monedas: [],
      config: {
        wrap: false, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only
      },
      proveedorSel: {},
      proveedores: [],
      tema: 'proveedor',
      datosFaltantes: [],
      isLoading: true,
    }
  },

  methods: {
      obtenerMonedas() {
        InventarioServices.getMonedas()
          .then( data => {
            this.monedas = data.map(this.convetirMonedas)
            this.obtenerOrdenCompra()
          })
          .catch()
      },

      convetirMonedas(moneda) {
        return {
          ...moneda,
          id: parseInt(moneda.id)
        }
      },

      obtenerProveedores () {
        InventarioServices.getProveedores()
          .then( resp => {
            this.proveedores = resp.map(this.convertirATypeahead)
            this.obtenerUbicaciones()
          })
          .catch( e => console.log(e) )
          this.isLoading = false
      },

      convertirATypeahead(proveedor) {
        return {
          ...proveedor,
          text: `${proveedor.nombre}`
        }
      },

      displayToast(tema, text, icon, actionText) {
          let toast = this.$toasted.show(text, { 
            theme: tema,
            position: "bottom-right", 
            duration : null,
            iconPack: 'fontawesome',
            icon: icon,
            action : {
              text : actionText,
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
      },

      addFactura () {
        this.isLoading = true
        const idProveedor = Object.keys(this.proveedorSel).length > 0 ? this.proveedorSel.id : 0
        
        InventarioServices.addFactura(this.factura, this.empresa, this.mes, this.area, this.partidaPresupuestal, this.ordenCompra, this.fechaFactura, this.serie, this.folio,
         this.UUID, idProveedor, this.RFC, this.moneda, this.monto, this.concepto, this.fechaPago, this.metodoPago)
        .then(res => {
            console.log(res)
          })
        .catch(error => console.log(error))  
      },
      
      obtenerOrdenCompra () {
      let year = moment().format('YY')
      let month = moment().format('MM')
      
      this.ordenCompra = `DUCTER-${year}${month}-`
      this.isLoading = false
    },

   },

    computed: {
      ...mapState(['permisos'])
    }
  }
  
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/NuevaFactura.vue